<template>
  <section class="compare-yourself">
    <section :class="device" class="wrapper">
      <div :class="containerClass">
        <section class="desc">
          <h6 class="cls-font">
            Assess your data, AI and machine learning skills vs industry experts and organizations.
          </h6>
          <div class="images-companies">
            <div v-for="source in sourcesCompanies" :key="source">
              <img
                v-lazy-load :data-src="
                  require(`~/assets/img/landing-page/compare-yourself/${source}.png`)
                "
                class="img-desc"
              />
            </div>
          </div>
          <div v-if="$mq === 'desktop'" class="images-universities">
            <div v-for="source in sourcesUniversities" :key="source">
              <img
                v-lazy-load :data-src="
                  require(`~/assets/img/landing-page/compare-yourself/${source}.png`)
                "
                class="img-desc"
              />
            </div>
          </div>
        </section>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  computed: {
    containerClass() {
      switch (this.$mq) {
        case "desktop":
          return "compare-yourself-inner all-centered";
        default:
          return "compare-yourself-inner";
      }
    },
    device() {
      switch (this.$mq) {
        case "desktop":
          return "";
        case "tablet":
          return "tablet";
        default:
          return "mobile";
      }
    },
    sourcesCompanies() {
      return this.$mq === "desktop"
        ? [
            "google",
            "facebook",
            "pinterest",
            "amazon-web-services",
            "upstart",
            "walmart-labs",
            "landing-ai"
          ]
        : [
            "google",
            "facebook",
            "pinterest",
            "amazon-web-services",
            "upstart",
            "walmart-labs",
            "landing-ai",
            "stanford",
            "berkeley",
            "carnegie-mellon",
            "circle-logo",
            "nus",
            "tree-logo",
            "university-of-cambridge"
          ];
    },
    sourcesUniversities() {
      return [
        "stanford",
        "berkeley",
        "carnegie-mellon",
        "circle-logo",
        "nus",
        "tree-logo",
        "university-of-cambridge"
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.compare-yourself {
  //background: white;

  .wrapper {
    padding: 4rem 1.5rem 4rem 1.5rem;

    .compare-yourself-inner {
      .desc {
        %images-section {
          display: grid;

          grid-template-rows: 60px;
          margin: auto;
          margin-top: 2rem;
          justify-content: center;
          div {
            img {
              padding: 0.8rem;
              max-height: 100%;
              max-width: 100%;

              margin-top: 1rem;
            }
          }
        }

        .images-companies {
          @extend %images-section;
          grid-template-columns: repeat(auto-fill, 120px);
          max-width: 840px;
        }

        .images-universities {
          @extend %images-section;
          max-width: 840px;
          grid-template-columns: repeat(auto-fill, 120px);
        }
      }
    }
    &.mobile {
      padding: 2rem 1.5rem 2rem 1.5rem;
      .compare-yourself-inner {
        .desc {
          .cls-font {
            margin-bottom: 0;
          }
          .images-companies {
            margin-top: 1rem;
            img {
              margin-top: 0.5rem;
            }
          }
        }
      }
    }
  }
}
.cls-font {
  color: black; /* #929292;*/
  font-weight: 700;
  line-height: 23.54px;
  size: 18px;
  text-align: center;
  letter-spacing: 0.03px;
  align-items: center;
}
</style>
